import { View } from "@gluestack-ui/themed";
import { PreProposalScreens } from "@repo/core/screens/PreProposal";

const PreProposalsConfirmTokenScreen = () => {
  return (
    <View flex={1} h="$full" w="$full">
      <PreProposalScreens.ConfirmToken />
    </View>
  );
};

export default PreProposalsConfirmTokenScreen;
